import classes from "./Introduction.module.css";
import React, { useEffect, useContext, useState } from "react";
import { images } from "../../assets/img";
import BookNowBtn from "../BookNowBtn";
import RemoteConfig from "../../services/RemoteConfig";
import AuthContext from "../../store/auth-context";
import { NAIL_SHOP_INFO } from "../../utils/Const";
import useCheckIsMobile from "../../hook/useCheckIsMobile";

//ABOUT US
const Introduction = (props) => {
  const { introductionRef } = props || {};
  const { isFetchActivateRemoteConfig } = useContext(AuthContext);
  const [image, setImage] = useState(images.nail_shop1);
  const isMobile = useCheckIsMobile();

  // useEffect(() => {
  //   const introduction_image = RemoteConfig.getConfigValue("introduction_image");
  //   introduction_image && setImage(introduction_image);
  // }, [isFetchActivateRemoteConfig]);

  return (
    <div ref={introductionRef} className={classes.introduction}>
      <div className={classes.introHeader}>
        <h2 className={classes.cursiveText}>{NAIL_SHOP_INFO.name}</h2>
      </div>
      <div className={classes.rowWrapper}>
        <img alt={"Intro"} src={image} className={classes.introImg} />
        <div className={classes.introTextContainer}>
          <div>
            <h1>{"Where Beauty Meets Serenity"}</h1>
            <h3 className={classes.greyIntroTextContainer}>
              {NAIL_SHOP_INFO.name} – A Premier Destination for Refined Elegance
            </h3>
          </div>
          <p className={classes.greyIntroTextContainer}>
            At {NAIL_SHOP_INFO.name}, we blend exceptional artistry with a tranquil ambiance to create an experience of true indulgence. From timeless classics such as a perfect manicure to bespoke, hand-crafted nail art, our dedicated team is committed to transforming your vision into a masterpiece.
          </p>
          <p className={classes.greyIntroTextContainer}>
            {`Each visit is more than a treatment—it is a moment of relaxation, rejuvenation, and luxury. With meticulous attention to detail and the highest standards of care, we ensure your nails not only look flawless but remain healthy and radiant.\nDiscover why discerning guests choose Friendly Nail & Beauty Spa as their sanctuary for beauty, wellness, and elegance.`}
          </p>
          <BookNowBtn />
        </div>
      </div>
    </div>
  );
};

export default Introduction;
